import { toast } from "../universal/toast";

export const UNVERIFIED_ADD_FRIEND_MESSAGE =
    "You can't add friends until your account is verified.";

export const UNVERIFIED_TARGET_ADD_FRIEND_MESSAGE =
    "You can't add this player because this account isn't verified yet.";

export function canSendFriendRequests(user) {
    return (
        String(user?.accountStatus || "")
            .trim()
            .toLowerCase() === "verified"
    );
}

export function canReceiveFriendRequests(user) {
    return canSendFriendRequests(user);
}

export function notifyIfCannotSendFriendRequest(user) {
    if (canSendFriendRequests(user)) return false;
    toast.warning(UNVERIFIED_ADD_FRIEND_MESSAGE, { durationMs: 4500 });
    return true;
}

export function notifyIfTargetCannotReceiveFriendRequest(user) {
    if (canReceiveFriendRequests(user)) return false;
    toast.warning(UNVERIFIED_TARGET_ADD_FRIEND_MESSAGE, { durationMs: 4500 });
    return true;
}

export function getPendingRequestRecipientSteamId(request) {
  if (!request || typeof request !== "object") return null;
  return request.toUserSteamId || request.toUser || null;
}

export function isPendingRequestForRecipient(request, recipientSteamId) {
  return (
    String(getPendingRequestRecipientSteamId(request)) === String(recipientSteamId)
  );
}

export function getIncomingRequestSenderSteamId(request) {
  if (!request || typeof request !== "object") return null;
  return (
    request.fromUser?.steamId ||
    request.fromUserSteamId ||
    request.fromUser ||
    null
  );
}

export function visibleIncomingFriendRequests(requests) {
  const seen = new Set();
  const visible = [];

  for (const request of requests || []) {
    const nickname = String(request?.fromUser?.nickname || "").trim();
    const senderSteamId = getIncomingRequestSenderSteamId(request);
    if (!senderSteamId || !nickname || nickname === "Unknown User") {
      continue;
    }

    const key = String(senderSteamId);
    if (seen.has(key)) continue;
    seen.add(key);
    visible.push(request);
  }

  return visible;
}
